// extracted by mini-css-extract-plugin
module.exports = {"errorMsg":"error-message_errorMsg__3-DGv"};